import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
 

const { useHistory } = require('react-router-dom')

interface Props {
  
}
const ProDiscountsScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)

  return (
    <div className="wrapper">
      <Headerbar
        title={'Parrainage'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <FadeIn>

              <div className="row">
                <div className="info-box col-sm">
                  <span className="info-box-icon bg-success"><i className="fa fa-code"></i></span>

                  <div className="info-box-content">
                    <span className="info-box-text">Votre code</span>
                    <span className="info-box-number">{user.code || 'XXX-XXX'}</span>
                  </div>
                </div>
                <div className="info-box col-sm">
                  <span className="info-box-icon bg-success"><i className="fa fa-shield-alt"></i></span>

                  <div className="info-box-content">
                    <span className="info-box-text">Activations</span>
                    <span className="info-box-number">{user.godchildren_count || 0}</span>
                  </div>
                </div>
                <div className="info-box col-sm">
                  <span className="info-box-icon bg-success"><i className="fa fa-trophy"></i></span>

                  <div className="info-box-content">
                    <span className="info-box-text">Conversions</span>
                    <span className="info-box-number">{user.godchildren_conversions || 0}</span>
                  </div>
                </div>
              </div>

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProDiscountsScreen